(function metadataDetailControllerDefinition() {
    'use strict';

    angular.module('Metadata')
        .controller('MetadataDetailController', [
            '$scope', '$state', 'errorsExtend', '$stateParams', 'metadataService',
            function metadataDetailController($scope, $state, errors, $stateParams, metadataService) {
                metadataService.getById($stateParams.id).then(function (result) {

                    $scope.metadata = {
                        id: result.id,
                        systemName: result.systemName,
                        label: result.name,
                        dataType: result.type,
                        organizationalUnitId: result.organizationUnitId,
                        organizationalUnitName: result.organizationUnitName,
                        attributes: []
                    };

                    if (result.optionValues && result.optionValues.length > 0) {
                        $scope.metadata.attributes.push({
                            type: $scope.metadata.dataType,
                            values: result.optionValues
                        });
                    }

                }, function (error) {
                    errors.showError(error);
                    $state.go('metadata-find');
                });

                $scope.cancel = function () {
                    $state.goBack("metadata-find");
                };
            }
        ]);
})();